<template>
  <div class="order-details-dialog">
    <el-dialog
        v-loading="loading"
        :fullscreen="true"
        :close-on-press-escape="false"
        :show-close="false"
        :close-on-click-modal="false"
        :visible.sync="formVisible">
      <div
          id="one-off-request-title"
          class="one-off-request-title-bar">
        <button
            v-if="!showFinalStep"
            type="button"
            class="el-dialog__headerbtn"
            style="right: unset; left: 20px"
            aria-label="Back"
            @click="back">
          <i class="el-dialog__close el-icon el-icon-arrow-left"></i>
        </button>
        <div class="order-number">
          One-off
        </div>
        <button
            type="button"
            class="el-dialog__headerbtn"
            aria-label="Close"
            @click="$emit('update:visible', false)">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </button>
        <StepProgressBar
            :total-steps="totalSteps"
            :current-step="currentStep" />
      </div>
      <div
          v-if="!loading"
          id="one-off-request-body"
          class="one-off-request-body">
        <div class="one-off-request-steps">
          <StepFlowButton
              buttontext="Step 1: Review customer details"
              :isactive="isActive1"
              :current-value="1"
              @go-back="previous" />
          <StepFlowButton
              buttontext="Step 2: Search and choose item"
              :isactive="isActive2"
              :current-value="2"
              @go-back="previous" />
          <StepFlowButton
              buttontext="Step 3: Select one-off reason"
              :isactive="isActive3"
              :current-value="3"
              @go-back="previous" />
          <StepFlowButton
              buttontext="Step 4: One-off summary"
              :isactive="isActive4"
              :current-value="4"
              @go-back="previous" />
        </div>
        <div style="border: 1px solid #DEE5EC;"></div>
        <div
            id="one-off-request-data"
            class="one-off-request-data">
          <OneOffSummary
              v-if="currentStep===4 && displayFinalStep"
              :loading.sync="loading"
              :device="selectedItem"
              :selected-name="selectedReasons.name"
              :customer="customerDetails"
              :address="customerAddress"
              :created-on="createdOn" />
          <OneOffReasons
              v-if="currentStep===3 && !displayFinalStep"
              :device="selectedItem"
              :loading.sync="loading"
              :selected-group="selectedReasons.group"
              :selected-reason="selectedReasons.reason"
              @selected-group-and-reason="getSelectedReasons" />
          <ChooseOneOff
              v-if="currentStep===2"
              :country="customerAddress.country"
              :state="customerAddress.state"
              :zip-code="customerAddress.zip_code"
              :expedited="shippingOptions.expedited"
              :selected-item.sync="selectedItem" />
          <ReviewCustomerDetailsAddress
              v-if="currentStep===1 && !isEditDetailsStep"
              :loading="loading"
              :edit-details.sync="isEditDetailsStep"
              :filled.sync="customerDetailsFilled"
              :customer="customerDetails"
              :address="customerAddress" />

          <div
              v-if="currentStep===1 && !isEditDetailsStep"
              class="expedited-shipping-option flex flex-auto flex-col">
            <div class="title">
              Shipping Options
            </div>
            <el-card
                shadow="never"
                style="width: 20rem;">
              <ExpeditedFormButton :expedited.sync="shippingOptions.expedited" />
            </el-card>
          </div>

          <EditCustomerDetail
              v-if="currentStep===1 && isEditDetailsStep"
              ref="editCustomer"
              :allvalid.sync="editCustomerEnableSave"
              :customer.sync="customerDetails"
              :address.sync="customerAddress" />
        </div>
      </div>
      <div
          id="one-off-request-footer"
          class="one-off-request-footer">
        <el-checkbox
            v-if="showAddressConfirmationCheck"
            v-model="isConfirmed"
            class="confirm-checkbox"
            style="margin-right: 24px">
          Customer details and address are correct.
        </el-checkbox>
        <el-button
            v-if="showBack"
            class="action_button back"
            @click="back">
          Back
        </el-button>
        <el-button
            v-show="showNext"
            :disabled="isNextDisabled"
            class="action_button"
            type="primary"
            @click="next">
          Next
        </el-button>
        <el-button
            v-show="currentStep === 3 && !displayFinalStep"
            :disabled="isReasonSelected"
            class="action_button"
            type="primary"
            @click="finalStep">
          Submit
        </el-button>
        <el-button
            v-if="showCancel"
            class="action_button back"
            style="color: #1998d5 !important; margin-right: 2px;"
            @click="cancel">
          Cancel
        </el-button>
        <el-button
            v-if="showSaveChanges"
            type="primary"
            :disabled="!editCustomerEnableSave"
            class="action_button"
            @click="saveChanges">
          Save Changes
        </el-button>
        <el-button
            v-show="currentStep === 4 && displayFinalStep"
            type="primary"
            class="action_button"
            @click="exit">
          Done
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  createNamespacedHelpers,
  createNamespacedHelpers as module,
} from "vuex";
import StepFlowButton from "../Return/StepFlowButton.vue";
import StepProgressBar from "../StepProgressBar.vue";
import ChooseOneOff from "./ChooseOneOff.vue";
import ReviewCustomerDetailsAddress from "../../ReplacementWidget/ReviewCustomerDetailsAddress.vue";
import EditCustomerDetail from "../../ReplacementWidget/EditCustomerDetail.vue";
const { mapGetters: accountGetters } = module("db/account");
import axios from "axios";
import OneOffReasons from "./OneOffReasons.vue";
import OneOffSummary from "./OneOffSummary.vue";
import TimeZoneFormatter from "@/helpers/TimeZoneFormatterHelper";
import ExpeditedFormButton from "../../RequestHelpers/ExpeditedFormButton.vue";
import ChooseReplacement from "../../ReplacementWidget/ChooseReplacement.vue";
import { isEmpty } from "lodash";
const { mapGetters: authGetters } = createNamespacedHelpers("auth");
const { mapActions: requestActions } = createNamespacedHelpers("db/requests");

export default {
  name: "OneOffFlow",
  components: {
    ChooseReplacement,
    ExpeditedFormButton,
    OneOffSummary,
    OneOffReasons,
    EditCustomerDetail,
    ReviewCustomerDetailsAddress,
    StepProgressBar,
    StepFlowButton,
    ChooseOneOff,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customerDetailsFilled: false,
      loading: true,
      currentStep: 1,
      totalSteps: 4,
      isConfirmed: false,
      isActive1: true,
      isActive2: false,
      isActive3: false,
      isActive4: false,
      displayFinalStep: false,
      formVisible: this.visible,
      selectedItem: {},
      isEditDetailsStep: false,
      editCustomerEnableSave: false,
      shippingOptions: { expedited: false },
      customerDetails: {
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
      },
      customerAddress: {
        address1: "",
        address2: "",
        city: "",
        country: "",
        state: "",
        zip_code: "",
      },
      selectedReasons: {
        group: -1,
        reason: -1,
        name: "",
        label: false,
      },
      areReasonsSelected: false,
      createdOn: "",
    };
  },
  computed: {
    ...accountGetters(["customer"]),
    ...authGetters(["user"]),
    ...accountGetters(["customerId"]),
    isReasonSelected() {
      return this.currentStep === 3 && !this.areReasonsSelected;
    },
    showBack() {
      return this.currentStep > 1 && !this.showCancel && !this.displayFinalStep;
    },
    showCancel() {
      return this.currentStep === 1 && this.isEditDetailsStep;
    },
    showNext() {
      return this.currentStep < 3 && !this.isEditDetailsStep;
    },
    isNextDisabled() {
      return (
        (this.currentStep === 1 &&
          (!this.isConfirmed || !this.customerDetailsFilled)) ||
        (this.currentStep === 2 && isEmpty(this.selectedItem))
      );
    },
    showFinalStep() {
      return (
        (this.currentStep === 3 && this.displayFinalStep) ||
        this.currentStep === 4
      );
    },
    showSaveChanges() {
      return this.currentStep === 1 && this.isEditDetailsStep;
    },
    showAddressConfirmationCheck() {
      return (
        this.currentStep === 1 &&
        !this.isEditDetailsStep &&
        this.customerDetailsFilled
      );
    },
  },
  watch: {
    currentStep() {
      if (this.currentStep === 1) {
        this.isActive1 = true;
        this.isActive2 = false;
        this.isActive3 = false;
        this.isActive4 = false;
      }
      if (this.currentStep === 2) {
        {
          this.isActive1 = false;
          this.isActive2 = true;
          this.isActive3 = false;
          this.isActive4 = false;
        }
      }
      if (this.currentStep === 3) {
        {
          this.isActive1 = false;
          this.isActive2 = false;
          this.isActive3 = true;
          this.isActive4 = false;
        }
      }
      if (this.currentStep === 4) {
        {
          this.isActive1 = false;
          this.isActive2 = false;
          this.isActive3 = false;
          this.isActive4 = true;
        }
      }
    },
  },
  mounted() {
    this.getDefaultCustomerDetails();
    this.loading = false;
  },
  methods: {
    ...requestActions(["createRequest"]),
    getDefaultCustomerDetails() {
      this.customerDetails.first_name = this.customer.first_name;
      this.customerDetails.last_name = this.customer.last_name;
      this.customerDetails.email = this.customer.email;
      this.customerDetails.phone_number = this.customer.phone_number;
      let address = this.customer.locations[0].address;
      this.customerAddress.address1 = address.address1;
      this.customerAddress.address2 = address.address2;
      this.customerAddress.city = address.city;
      this.customerAddress.state = address.state;
      this.customerAddress.zip_code = address.zip_code;
      this.customerAddress.country = address.country;
    },
    previous(clickedValue) {
      if (clickedValue < this.currentStep) {
        this.currentStep = clickedValue;
      }
    },
    exit() {
      this.$emit("update:visible", false);
    },
    back() {
      if (this.currentStep === 1) {
        this.$emit("update:visible", false);
      } else this.currentStep--;
    },
    next() {
      if (this.isNextDisabled) return;
      if (this.currentStep === this.totalSteps) return;
      else this.currentStep++;
    },
    cancel() {
      if (this.currentStep === 1 && this.isEditDetailsStep) {
        this.isEditDetailsStep = false;
        this.editCustomerEnableSave = false;
        this.isConfirmed = false;
      }
    },
    saveChanges() {
      this.$refs.editCustomer.saveChanges();
      this.isEditDetailsStep = false;
    },
    getSelectedReasons(selectedReason) {
      this.areReasonsSelected = selectedReason.allowNext;
      this.selectedReasons = {
        group: selectedReason.group,
        reason: selectedReason.reason,
        name: selectedReason.name,
        label: selectedReason.label,
      };
    },
    finalStep() {
      this.loading = true;
      let payload = this.createPayload();
      this.createRequest(payload)
        .then((response) => {
          if (response.data) {
            this.createdOn = TimeZoneFormatter.formattedTime(
              response.data.created_at
            );
            this.displayFinalStep = true;
            this.currentStep = this.currentStep + 1;
          } else {
            console.log("Invalid response");
          }
        })
        .catch((error) => {
          this.$forEachPlcError(error, (msg) => {
            this.$notify({ type: "error", message: msg });
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createPayload() {
      let fullName =
        this.customerDetails.first_name + ", " + this.customerDetails.last_name;
      let customer_request = {
        admin_user_id: this.user.id,
        customer_address_1: this.customerAddress.address1,
        customer_address_2: this.customerAddress.address2,
        customer_city: this.customerAddress.city,
        customer_country: this.customerAddress.country,
        customer_email: this.customerDetails.email,
        customer_name: fullName,
        customer_phone: this.customerDetails.phone_number,
        customer_request_reasons_attributes: [
          {
            reason_id: this.selectedReasons.reason,
            quantity: 1,
          },
        ],
        customer_state: this.customerAddress.state,
        customer_zip: this.customerAddress.zip_code,
        type: "CustomerRequest::OneOff",
        requested_by_area: "customer_support",
        owner_id: this.customerId,
        new_device_kind: this.selectedItem.product.kind,
        new_device_color: this.selectedItem.color,
        expedited: false,
        device_price: this.selectedItem,
      };
      return customer_request;
    },
  },
};
</script>

<style scoped>
.one-off-request-dialog {
  .el-dialog el-dialog__header {
    padding: 0 !important;
    width: 100%;
    display: none !important;
  }

  .el-dialog el-dialog__body {
    padding: 0 !important;
    height: inherit;
  }
}
.one-off-request-title-bar {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9;
  height: 64px;
  background: #ffffff;

  .order-number {
    position: absolute;
    height: 24px;
    left: 72px;
    right: 72px;
    top: calc(50% - 24px / 2);

    /* body/normal-medium */

    font-family: "Equip", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */

    display: table-cell;
    align-items: center;
    text-align: center;

    /* 🖥 light/content/base */
    color: #424242;
  }
}
.one-off-request-body {
  top: 64px;
  bottom: 64px;
  margin-bottom: 64px;
  position: relative;
  display: flex;
  flex-direction: row;
  overflow-y: scroll;
  min-height: calc(100% - 160px);
  background: rgb(250, 251, 252);
  padding-bottom: 74px;

  .one-off-request-steps {
    width: 532px;
    flex: 1;
    background: #ffffff;
    padding: 40px;
  }
  .one-off-request-data {
    flex: 3;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    padding: 40px;
    .expedited-shipping-option {
      gap: 8px;
      .title {
        color: #6e6e6e;
        font-weight: 500;
        line-height: 24px;
      }
    }
  }
}
.one-off-request-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  height: 64px;
  background: #ffffff;
  filter: drop-shadow(0px -1px 4px rgba(0, 0, 0, 0.15));
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 40px;
}

.action_button {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 16px !important;
  gap: 8px;
  width: 277px;
  height: 48px;
  flex: none;
  order: 0;
  flex-grow: 0;
  border: 1px solid #1998d5 !important;
  border-radius: 8px !important;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 28px !important;
  text-align: center !important;

  .back {
    color: #1998d5 !important;
  }
}
</style>
